import { useId } from 'react';

import type { ChangeEvent } from 'react';

import styles from 'components/MultiSelect/MultiSelect.module.css';
import { Checkbox } from 'components/Checkbox';
import { Label } from 'components/Label';

export interface MultiSelectItemProps {
  label: string;
  value: string | number;
  checked: boolean;
  disabled?: boolean;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
}

export function MultiSelectItem({ label, value, checked, disabled = false, onChange }: MultiSelectItemProps) {
  const id = useId();

  return (
    <li className={styles['multi-select__item']}>
      <Checkbox id={id} value={value} checked={checked} onChange={onChange} disabled={disabled} />
      <Label htmlFor={id} noFontWeight={!checked}>
        {label}
      </Label>
    </li>
  );
}
